import styled from 'styled-components'
import { darken, rgba } from 'polished';

export const Container = styled.div`
  gap: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const Actions = styled.div`
  display: flex;
  gap: 14px;
  height: fit-content;
  flex-wrap: wrap;
  &>*{
    flex: 1;
  }
`

export const Confirmation = styled.div`
  --shadow-color :${(props) => rgba(darken(.2, props.theme.colors.warning), .3)};
  padding: 8px 12px 12px 12px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: flex-start;
  gap: 2px;
  position: relative;
  box-shadow: var(--shadow-color) 5px 5px 5px;

`;
